<template>
  <div>
    <input type="hidden" id="isPrint" value="false" />
    <input type="hidden" id="hidePrintTitle" value="false" />
    <input type="hidden" id="headerDate" value="false" />
    <input type="hidden" id="headerDateType" value="yearMonth" />

    <vs-tabs v-if="tabList.length > 0 && showOnlyOne" :value="currentTabIndex">
      <vs-tab v-for="(tab, tabIndex) in tabList" :key="`tab_${tab.label}_${tabIndex}`" :label="tab.label" @click="moveTab(tabIndex, tab)"></vs-tab>
    </vs-tabs>

    <!-- list -->
    <div v-if="tab && this.tabPageInfo.pageType === 'list'">
      <table-list-page
        :board-id="boardId"
        :board-slug="tab.slug"
        route-c="write|tab"
        route-u="write|update|tab"
        :permission="permission"
        :download="tab.label"
        :create="listUseCreateButton"
        :approval="tab.isApproval"
        :move-project="!(projectId > 0)"
        :by-current-location="tab.byCurrentLocation"
        :nav="nav"
        :heads="listTableHeads"
        :getCol="listGetTableColumn"
        :query-search-mode="true"
        :multi-print="tab.isApproval || isMobile ? false : isAdmin"
        :total-count-visible="true"
        @clickMultiPrint="listOnClickMultiPrint"
        @load="listOnLoadData"
      >
        <template #search>
          <component :is="searchComponent" :value="nav.value" @input="listOnChangeSearch" />
        </template>
        <template #targets>
          <search-nav-item-tartgets v-if="nav.value && nav.value.companies" v-model="nav.value.companies" />
        </template>
        <template #toolRight>
          <vs-button v-if="listUseCreateButton && permission.c && tab.moveBoardWrite" color="secondary" @click="onClickMoveBoard" class="mb-4 flex-1 xl:flex-none">{{ tab.moveBoardWrite.label }}</vs-button>
        </template>
      </table-list-page>
    </div>

    <!-- write -->
    <div v-if="tab && this.tabPageInfo.pageType === 'write'">
      <approval-document2
        v-if="tab.isApproval"
        :tab="tab"
        :doc-info="writeDocInfo"
        :docProjectId="writeDocProjectId"
        :permission="permission"
        :usePrevPost="tab.usePrevPost"
        :use-print="tab.usePrint === true || tab.usePrint === false ? tab.usePrint : true"
        :print-label="tab.printLabel"
        :use-delete="typeof tab.useDelete === 'boolean' ? tab.useDelete : true"
        @board="setBoard"
        @delete="writeOnClickApprovalDelete"
        @close="writeOnClickApprovalClose"
        @recall="writeOnClickApprovalRecall"
        @upload="writeOnClickApprovalUpload"
        @update="writeOnClickApprovalSave"
        @save="writeOnClickApprovalSave"
        @approval="writeOnClickApprovalOk"
        @reject="writeOnClickApprovalNo"
        @prevPost="writeOnClickPrevPost"
        @retempsave="writeOnClickReTempsave"
      >
        <template #header="props">
          <div v-if="tab.useHeaderDate" class="h4 grid xl:flex gap-4" style="align-items: center">
            <div id="print-label">
              <p class="h4 flex" style="align-items: center">{{ tab.label }}</p>
            </div>

            <div v-if="tab.headerDateType === 'date'" class="flex items-center">
              <date-selector class="mr-2" style="width: 140px" v-model="form.header.date" :readonly="props.board.readonly || !!postId"/>
            </div>
            <div v-else class="flex items-center">
              <vs-input class="mr-2" style="width: 100px" v-model="form.header.year" :readonly="props.board.readonly || !!postId" />년
              <vs-input type="number" class="ml-4 mr-2" style="width: 100px" v-model="form.header.month" :readonly="props.board.readonly || !!postId" min="1" max="12" />월
            </div>
          </div>
          <div v-else id="print-label">
            <p class="h4 flex" style="align-items: center">{{ tab.label }}</p>
          </div>
        </template>

        <template #body="props">
          <component
            ref="approvalDocument"
            :is="tabPageInfo.component"
            :tab="tab"
            :board="props.board"
            :header="form.header"
            :is-print="props.isPrint"
            v-model="form.body"
            @EnableSave="setEnableSave"
          />
          <FileDownload v-if="!props.isPrint && tab.visibleFileDownload" :isChange="isAdmin"/>
        </template>
      </approval-document2>
      <normal-document
        v-else
        ref="refNormalDocument"
        :tab="tab"
        :created="useCreated"
        :header="form.header"
        :docProjectId="writeDocProjectId"
        :permission="permission"
        :usePrevPost="tab.usePrevPost"
        :use-print="tab.usePrint === true || tab.usePrint === false ? tab.usePrint : true"

        :use-print-title="typeof tab.usePrintTitle === 'boolean' ? tab.usePrintTitle : true"
        :use-delete="typeof tab.useDelete === 'boolean' ? tab.useDelete : true"
        :print-label="tab.printLabel"

        @board="setBoard"
        @move="moveTabPage"
        @remove="writeOnClickNormalRemove"
        @save="writeOnClickNormalSave"
        @prevPost="writeOnClickPrevPost"
      >
        <template #header="props">
          <div v-if="tab.useHeaderDate" class="h4 grid xl:flex gap-4" style="align-items: center">
            <div id="print-label">
              <p class="h4 flex" style="align-items: center">{{ tab.label }}</p>
            </div>

            <div v-if="tab.headerDateType === 'date'" class="flex items-center">
              <date-selector class="mr-2" style="width: 140px" v-model="form.header.date" :readonly="props.board.readonly || !!postId"/>
            </div>
            <div v-else class="flex items-center">
              <vs-input type="number" class="mr-2" style="width: 100px" v-model="form.header.year" :readonly="props.board.readonly || !!postId" :min="1900" />년
              <vs-input type="number" class="ml-4 mr-2" style="width: 100px" v-model="form.header.month" :readonly="props.board.readonly || !!postId" :min="1" :max="12" />월
            </div>
          </div>
          <div v-else id="print-label" class="h4 grid xl:flex gap-4" style="align-items: center">
            <p class="h4 flex" style="align-items: center">{{ tab.label }}</p>
          </div>
        </template>
        <template #body="props">
          <component
            ref="normalDocumentComponent"
            :is="tabPageInfo.component"
            :tab="tab"
            :board="props.board"
            :header="form.header"
            :is-print="props.isPrint"
            :docProjectId="writeDocProjectId"
            v-model="form.body"
            @saveButtonControl="(value) => writeSaveButtonControl(value)"
            @removeButtonControl="(value) => writeRemoveButtonControl(value)"
            @setPrevBoardOptions="(value) => writeSetPrevBoardOptions(value)"
            @EnableSave="setEnableSave"
          />
          <FileDownload v-if="!props.isPrint && tab.visibleFileDownload" :isChange="isAdmin"/>
        </template>
      </normal-document>
    </div>

    <!-- page -->
    <div v-if="tab && this.tabPageInfo.pageType === 'page'">
      <component :is="tabPageInfo.component" />
    </div>

    <!-- excel-upload -->
    <div v-if="tab && this.tabPageInfo.pageType === 'excel-upload'">
      <component :is="tabPageInfo.component" :board="board" :header="form.header" @customAlert="customAlert" @save="writeOnClickSaveMultiple"/>
    </div>

    <!-- excel-upload-bulk -->
    <div v-if="tab && this.tabPageInfo.pageType === 'excel-upload-bulk'">
      <component :is="tabPageInfo.component" :board="board" :header="form.header" @customAlert="customAlert" @save="writeOnClickSaveMultiple"/>
    </div>


    <!-- multiPrintPopup -->
    <popup-multi-print-viewer
      v-if="tab && this.tabPageInfo.pageType === 'list'"
      v-model="popup.multiPrintViewer"
      :boardId="boardId"
      :isApproval="tab.isApproval"
      :searchComponent="searchComponent"
      :nav="nav"
      :method="{
        getContent: this.getContent,
        getCreatedDate: this.getCreatedDate,
        getCompanyName: this.getCompanyName,
        getContentTargetList: this.getContentTargetList,
        onNameBlur: this.onNameBlur,
        getContentRiskList: this.getContentRiskList,
        getContentStringList: this.getContentStringList,
        comma: this.comma,
      }"
    ></popup-multi-print-viewer>

    <popup-load-prev-board
      v-if="popup.loadPrevBoard"
      v-model="popup.loadPrevBoard"
      :title="writePrevBoardOptions.title"
      :set-board-id="writePrevBoardOptions.boardId"
      @selectRowData="prevBoardSelectRow" />
  </div>
</template>

<script>
import HttpRequest from "@/util/HttpRequest";
import moment from "moment";
import normalSearchNav from "@/views/boards/components";
import SearchNavItemTartgets from "@/views/boards/components/SearchNavItemTartgets.vue";
import tabItems from "@/views/boards/tab/tab-items";
import includeSinglePage from "@/views/boards/single-page/include";
import TableListPage from "@/views/list/TableListPage.vue";
import PopupMultiPrintViewer from "@/popup/PopupMultiPrintViewer.vue";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";
import NormalDocument from "@/views/write/document/NormalDocument.vue";
import ApprovalDocument2 from "@/views/write/document/ApprovalDocument2.vue";
import FileDownload from "@/components/FileDownload.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  components: {
    DateSelector,
    FileDownload,
    ApprovalDocument2,
    NormalDocument,
    PopupLoadPrevBoard,
    PopupMultiPrintViewer,
    SearchNavItemTartgets,
    TableListPage,
    FieldsList: () => import("@/views/fields/FieldsList.vue"),
  },
  watch: {
    menuList () {

      // api 를 통해서 메뉴를 불러오기 때문에, beforeMount 에서 실행하면 menuList 가 비어있는 상태로 실행되어서
      // watch 를 사용하여 menuList 가 변경되면 실행하도록 한다.
      // router.push 를 통해서 이동할 때는 menuList 가 변하지 않기 때문에, beforeMount 에서 실행하도록 한다.
      this.initBreadcrumb();
      this.initTab();
    },
    tabList () {
      if (this.tabList.length > 0) {
        this.tab = this.tabList[this.currentTabIndex];
      }
    }

  },
  computed: {
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    isMobile () {
      return !(this.$store.state.verticalNavMenuWidth === 'default')
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return this.$route.params.boardId ? this.$route.params.boardId : "";
    },
    boardSlug() {
      for (const tab of this.tabList) {
        if (`${tab.boardId}` === `${this.boardId}`) {
          return tab.slug;
        }
      }
      return "";
    },
    pageTitle () {
      return this.$store.state.menu.pageTitle;
    },
    postId() {
      return this.$route.params.postId ? this.$route.params.postId : "";
    },
    menuList() {
      return this.$store.state.menu.list;
    },
    currentMenu() {
      return this.__findNode(this.menuList, this.tabPageInfo.relatedPath);
    },
    tabPageInfo() {
      const pageType = this.$route.params.pageType ? this.$route.params.pageType : 'list';
      const tabKey = `${this.boardId}_${pageType}`
      const component = this.singlePage[pageType][tabKey.replaceAll('-', '')];
      const relatedPath = (!pageType || pageType === 'list' || pageType === 'write') ? `/tab/${this.boardId}` : `/tab/${this.boardId}/${pageType}`;
      return { pageType, tabKey, component, relatedPath }
    },
    singlePage() {
      const list = includeSinglePage.list;
      const write = includeSinglePage.write;
      const page = includeSinglePage.page;
      const excelupload = includeSinglePage.excelUpload;
      const exceluploadbulk = includeSinglePage.excelUploadBulk;
      return { list, write, page, 'excel-upload':excelupload, 'excel-upload-bulk':exceluploadbulk };
    },
    /**
     * 현재 사용자가 프로젝트 관리자인지 확인합니다.
     * 프로젝트 관리자는 사업장을 등록/수정/삭제할 수 있습니다.
     * @returns {boolean}
     */
    isProjectManager() {
      const memberInfo = this.$store.state.member.memberInfo;
      if (memberInfo) {
        if (memberInfo.is_superuser) {
          return true;
        }

        const projects = memberInfo.projects;
        if (projects && projects.length > 0) {
          for (const project of projects) {
            if (`${project.id}` === `${this.projectId}`) {
              return project.pivot.is_manager;
            }
          }
        }
      }
      return false;
    },

    useCreated() {
      return this.enableSave;
    },

    /**
     * ================================================================
     * pageType === 'list'
     * ================================================================
     */
    searchComponent() {
      return normalSearchNav[`NormalSearchNav${this.boardId}`];
    },

    // 리스트의 [신규작성] 작성 버튼 사용 여부
    listUseCreateButton() {
      const component = this.tabPageInfo.component || {};
      if (component.hideCreateButton) return !component.hideCreateButton()
      return this.projectId > 0;
    },

    listTableHeads() {
      if (this.tabPageInfo.component && this.tabPageInfo.component.getHead) {
        const heads = this.tabPageInfo.component.getHead(this.projectId);

        // table-list-page 에서 sort-key 로 사용하기 위해 keyName 을 추가해준다.
        if (heads.length > 0) {
          for (const head of heads) {
            head.keyName = head.name;
          }
        }

        if (parseInt(this.projectId) === 3) {
          if (heads.length > 0 && heads[0].name === "사업장명") {
            heads[0].name = "사업명";
          }
        }
        return heads;
      }

      return [];
    },


  }, // computed

  data () {
    return {
      tabItems,
      currentTabIndex: 0,
      showOnlyOne: false,
      tab: {},
      tabList: [],
      enableSave: true,
      permission: { c: 0, r: 0, u: 0, d: 0, v: 0 },

      board: {
        projectTitle: this.$store.state.project.projectInfo.field_name,
        writer: {}, //작성자 정보
        readonly: false, // 읽기전용인가
        isPrint: false,
        viewSaveBtn: true,
        viewRemoveBtn: true,
      },

      // list
      nav: {
        projectId: 0,
        dateTarget: "created_at",
        orderTarget: parseInt(this.$route.params.boardId) === 299 ? "updated_at" : "created_at",
        orderDirection: "desc",
        date: { year: new Date().getFullYear(), month: "" },
        value: {},
        page: {},
        keyword: [], // 나중에 삭제해야함.
      },
      listCompanyList: [],

      // write / ExcelUpload / ExcelUploadBulk
      form: {
        header: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, date: new Date().format('yyyy-MM-dd') },
        body: {},
      },
      writeOldForm: {},
      writeDocInfo: {},
      writeDocProjectId: {},
      writePrevBoardOptions: {
        boardId: Number(`${this.boardId}`),
        title: '이전 문서 불러오기',
        prevBoardSelectRow: undefined,
      },

      popup: {
        multiPrintViewer: false,
        loadPrevBoard: false,
      },
    };
  },

  async created() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
    await this.$store.dispatch("project/LOAD_PROJECT", {project_id: this.projectId});
    await this.loadPermission();
  },

  beforeMount() {
    this.nav.projectId = this.projectId;
    this.initBreadcrumb();
    this.initTab();
    this.initBackButtonRouteGuard();
  },

  async mounted() {
    if (this.postId) {
      if (this.tab && this.tab.isApproval) {
        await this.writeLoadApprovalPost();
      } else {
        await this.writeLoadBoardPost();
      }
    } else if (this.tabPageInfo.pageType === 'list') {
      await this.listLoadCompanyList();
    }
  },

  methods: {
    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: title ? title : "오류가 발생했습니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },
    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },
    onClickMoveBoard() {
      this.moveTabPage('write');
    },
    moveTabPage(pageType) {
      const proj_id = `${this.projectId}`;
      const boardId = `${this.boardId}`;
      const query = this.$route.query;
      if (pageType === "list") {
        this.$router.push({ name: "list|tab", params: { pageType, proj_id, boardId }, query });
      } else if (pageType === "write") {
        this.$router.push({ name: "write|tab", params: { pageType, proj_id, boardId }, query });
      }
    },
    setEnableSave(enableSave) {
      this.enableSave = enableSave;
    },
    setBoard(board, approval) {
      this.board = board;
      this.approval = approval;
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.body;
      }
    },
    getHeader(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.header;
      }
    },
    getCreatedDate(data) {
      if (data === "") return "";
      return moment(data).format("YYYY-MM-DD");
    },
    getCompanyName(comId) {
      for (const com of this.listCompanyList) {
        if (com.id === comId) {
          return com.com_name;
        }
      }
    },
    onNameBlur(name) {
      const length = name.length;
      if (length > 2) {
        const first = name[0];
        const last = name[name.length - 1];
        let star = "";
        for (let index = 0; index < length - 2; index++) {
          star += "*";
        }
        name = first + star + last;
      } else if (length === 2) {
        const first = name[0];
        name = `${first}*`;
      }
      return name;
    },
    getContentRiskList(list) {
      let result = "";
      for (const data of list) {
        if (data.input_3) {
          if (typeof data.input_3 === 'string') {
            if (!result.includes(data.input_3)) {
              result += `${data.input_3},`;
            }
          }

          if (typeof data.input_3 === 'object') {
            const temp = data.input_3.toString().split(',')
            for (const t of temp) {
              if (t && !result.includes(t)) {
                result += `${t},`;
              }
            }

          }
        }
      }
      return result.substring(0, result.length - 1);
    },
    getContentTargetList(list) {
      let result = "";
      for (const data of list) {
        if (!result.includes(data.target)) {
          result += `${data.target},`;
        }
      }
      return result.substring(0, result.length - 1);
    },
    getContentStringList(list) {
      let result = "";
      for (const data of list) {
        if (!result.includes(data)) {
          result += `${data},`;
        }
      }
      return result.substring(0, result.length - 1);
    },
    getContentRiskTypeList(list) {
      let result = "";
      for (const data of list) {
        if (!result.includes(data.input_1)) {
          result += `${data.input_1},`;
        }
      }
      return result.substring(0, result.length - 1);
    },
    comma(str) {
      return `${str}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    // TODO : ======================== API ======================== //
    async loadPermission() {
      if (Number.isInteger(parseInt(this.boardId))) {
        let boards = this.$store.state.member.memberInfo.boards;
        if (!boards) {
          await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
          boards = this.$store.state.member.memberInfo.boards;
        }

        let board = boards.find((b) => parseInt(b.id) === parseInt(this.boardId));
        if (!!board && !!board.pivot) {
          if (board.pivot.project_id) {
            // 프로젝트에 맞는 권한이 있는지 다시 조사한다
            board = boards.find((b) => parseInt(b.pivot.board_id) === parseInt(this.boardId) && parseInt(b.pivot.project_id) === parseInt(this.projectId));
            this.permission = { ...board.pivot };
          } else {
            this.permission = { ...board.pivot };
          }
        }
      }
    },

    // TODO : ======================== Init ======================== //
    initBreadcrumb() {
      const breadcrumb = [{ title: "Home" }];
      if (this.currentMenu && this.currentMenu.path && this.currentMenu.path.length > 0) {
        for (const p of this.currentMenu.path) {
          breadcrumb.push({ title: p, note: this.currentMenu.note });
        }
      }

      if (breadcrumb.length > 1) {
        breadcrumb[breadcrumb.length - 1].active = true;
      }

      this.$store.commit("menu/UPDATE_PAGE_LIST", breadcrumb);
    },
    initTab() {
      // 현재 접속한 페이지의 형제 메뉴를 찾아 탭에 추가한다.
      const relatedPath = this.tabPageInfo.relatedPath;
      const nodeList = this.__findSiblingsNodeList(this.menuList, relatedPath);

      this.tabList = [];
      if (nodeList.length > 0) {
        for (const node of nodeList) {
          // 탭이 표기되지 않는 하나의 페이지인 경우
          if (node.visible === 'menu') {
            if (node.url === this.tabPageInfo.relatedPath) {
              const _url_path = node.url.split("/");
              const __index_tab = _url_path.indexOf("tab");
              const pageType = (_url_path.length > __index_tab + 2) ? _url_path[__index_tab + 2] : "list";
              const boardId = _url_path[__index_tab + 1];
              const tabLabel = node.name;
              this.addTab(pageType, boardId, tabLabel);
              break;
            }
          }

          if (node.visible === 'tab' || node.visible === 'tab_menu') {
            this.showOnlyOne = true;

            const _url_path = node.url.split("/");
            const __index_tab = _url_path.indexOf("tab");
            const pageType = (_url_path.length > __index_tab + 2) ? _url_path[__index_tab + 2] : "list";
            const boardId = _url_path[__index_tab + 1];
            const tabLabel = node.name;
            this.addTab(pageType, boardId, tabLabel);
          }
        }
      } else {
        // 현재 페이지가 메뉴에 없는 경우
        const _url_path = relatedPath.split("/");
        const __index_tab = _url_path.indexOf("tab");
        const pageType = (_url_path.length > __index_tab + 2) ? _url_path[__index_tab + 2] : "list";
        const boardId = _url_path[__index_tab + 1];
        this.addTab(pageType, boardId);
      }

      // 현재 페이지의 tabIndex 를 찾는다.
      const tabKey = this.tabPageInfo.tabKey.replaceAll("write", "list").replaceAll("-", "");
      for (let i = 0; i<this.tabList.length; i++) {
        if (this.tabList[i].tabKey === tabKey) {
          this.currentTabIndex = i;
          break;
        }
      }
    },
    initBackButtonRouteGuard() {
      const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
        let isNext = true
        if (this.tabPageInfo.pageType === 'write') {
          isNext = JSON.stringify(this.writeOldForm) === JSON.stringify(this.form) || confirm("저장하지 않은 데이터는 삭제됩니다. 닫으시겠습니까?");
        }
        if (isNext) {
          document.querySelectorAll(".con-vs-popup").forEach((el) => {
            el.style.display = "none";
          });
          next(true);
        }
      });
      this.$once("hook:destroyed", () => {
        backButtonRouteGuard();
      });
    },

    __findSiblingsNodeList(menuList, relatedPath) {
      if (menuList && menuList.length > 0) {
        for (const menu of menuList) {
          if (menu.url && menu.url.indexOf(relatedPath) > -1) {
            if (menu.submenu) {
              const list = this.__findSiblingsNodeList(menu.submenu, relatedPath);
              if (list.length > 0) {
                return list;
              }
            }
            return menuList;
          } else if (menu.submenu) {
            const list = this.__findSiblingsNodeList(menu.submenu, relatedPath);
            if (list.length > 0) {
              return list;
            }
          }
        }
      }
      return [];
    },
    __findNode(menuList, relatedPath) {
      if (menuList && menuList.length > 0) {
        for (const menu of menuList) {
          if (menu.url && menu.url.indexOf(relatedPath) > -1) {
            return menu;
          } else if (menu.submenu) {
            const node = this.__findNode(menu.submenu, relatedPath);
            if (node) {
              return node;
            }
          }
        }
      }
      return null;
    },

    // ======================== TAB ======================== //

    addTab(pageType, boardId, tabLabel) {
      if (pageType === "list" || pageType === "write") {
        this.addListTab(boardId, tabLabel)
      } else if (pageType === "page") {
        this.addPageTab(boardId, tabLabel)
      } else if (pageType === "excel-upload") {
        this.addExcelUploadTab(boardId, tabLabel)
      } else if (pageType === "excel-upload-bulk") {
        this.addExcelUploadBulkTab(boardId, tabLabel)
      }
    },
    addListTab(boardId, tabLabel) {
      const tabKey = `${boardId}_list`;
      const slug = `board-${boardId}`;
      const item = this.tabItems[boardId];
      if (item) {
        this.tabList.push({pageType: "list", ...item, tabKey, boardId, slug, label: tabLabel || item.label});
      }
    },
    addPageTab(boardId, tabLabel) {
      const tabKey = `${boardId}_page`;
      const slug = `board-${boardId}`;
      const item = this.tabItems[boardId];
      if (item) {
        this.tabList.push({pageType: "page", ...item, tabKey, boardId, slug, label: tabLabel || item.label});
      }
    },
    addExcelUploadTab(boardId, tabLabel) {
      const tabKey = `${boardId}_excelupload`;
      const slug = `board-${boardId}`;
      const item = this.tabItems[boardId];
      if (item) {
        this.tabList.push({pageType: "excel-upload", ...item, tabKey, boardId, slug, label: tabLabel || item.label});
      }
    },
    addExcelUploadBulkTab(boardId, tabLabel) {
      const tabKey = `${boardId}_exceluploadbulk`;
      const slug = `board-${boardId}`;
      const item = this.tabItems[boardId];
      if (item) {
        this.tabList.push({
          pageType: "excel-upload-bulk",
          ...item,
          tabKey,
          boardId,
          slug,
          label: tabLabel || item.label
        });
      }
    },
    moveTab(index, tab) {
      if (index === this.currentTabIndex) return;

      const boardId = tab.boardId;
      const pageType = tab.pageType;
      this.$router.push({
        name: this.projectId ? `${pageType}|tab` : `root|${pageType}|tab`,
        params: {boardId, pageType}
      });
    },

    // ======================== LIST ======================== //
    __checkCreatable(list) {
      const nowMonth = new Date().getMonth() + 1;
      let maxMonth = 0;
      for (const data of list) {
        if (data.user.company_id === this.myInfo.company_id) {
          if (maxMonth < Number(`${this.getHeader(data).month}`)) {
            maxMonth = Number(`${this.getHeader(data).month}`);
          }
        }
      }
      return maxMonth < nowMonth;
    },
    listOnLoadData(list) {
      if (this.boardId === 86 || this.boardId === 106 || this.boardId === 154 || this.boardId === 155 || this.boardId === 250) {
        this.create = this.__checkCreatable(list);
      }
    },
    async listLoadCompanyList() {
      const projectId = this.projectId;

      if (this.tab && this.tab.useListGetCompanyName) {
        const page = 1;
        const perPage = 10000;
        await this.$store.dispatch("company/LOAD_COMPANY_LIST", {
          page,
          perPage,
          projectId,
        });
        this.listCompanyList = this.$store.state.company.companyList;
      }

      await this.$store.dispatch("company/LOAD_COMPANY_TREE", { projectId });
    },
    listGetTableColumn(index, value) {
      if (this.tabPageInfo && this.tabPageInfo.component && this.tabPageInfo.component.getCol) {
        return this.tabPageInfo.component.getCol(index, value, {
          getContent: this.getContent,
          getCreatedDate: this.getCreatedDate,
          getCompanyName: this.getCompanyName,
          getContentTargetList: this.getContentTargetList,
          onNameBlur: this.onNameBlur,
          getContentRiskList: this.getContentRiskList,
          getContentStringList: this.getContentStringList,
          comma: this.comma,
        });
      }

      return "";
    },
    listOnClickMultiPrint() {
      this.popup.multiPrintViewer = true
    },
    listOnChangeSearch(value) {
      this.nav.value = value;
    },

    // TODO : ======================== WRITE / excel_upload / excel_upload_bulk ======================== //
    __maskName(name) {
      name = `${name}`.trim();
      // 이름이 2개 이상의 단어로 이루어져 있는 경우
      if (name.includes(" ")) {
        // 이름을 공백으로 분리
        const names = name.split(" ");
        // 성은 맨 뒤 단어로 판단
        const lastName = names[names.length - 1];
        // 나머지 이름에 대해 마스킹 처리
        const otherNames = names.slice(0, -1).map((n) => n.substring(0, Math.ceil(n.length / 2)) + "*".repeat(Math.floor(n.length / 2)));
        return [...otherNames, lastName].join(" ");
      }

      // 이름이 1개의 단어로 이루어져 있는 경우
      const length = name.length;
      if (length === 1) {
        return "*";
      } else if (length === 2) {
        return `${name[0]}*`;
      } else {
        return name[0] + "*".repeat(length - 2) + name[length - 1];
      }
    },
    __removeComma(str) {
      if (str) {
        const noneComma = `${str}`.replaceAll(",", "");
        return `${Number(noneComma)}`;
      }
      return "0";
    },
    /** 암호화 저장 관련 */
    __writeLoadApprovalPostContent(form) {
      const body = form.body;
      if (this.boardId === 117) {
        const targetKeys = [
          "inputC_1",
          "inputC_2",
          "inputC_4",
          "inputC_5",
          "inputC_7",
          "inputC_8",
          "inputC_9",
          "inputC_10",
          "inputC_11",
          "inputC_12",
          "inputC_13",
          "inputC_14",
          "inputC_15",
          "inputC_16",
          "inputC_17",
          "inputC_18",
          "inputC_19",
          "inputC_20",
          "inputD_1",
          "inputD_2",
          "inputD_3",
          "inputD_4",
          "inputD_5",
          "inputD_6",
          "inputD_7",
          "inputE_1",
          "inputE_2",
          "inputE_3",
          "inputE_4",
        ];
        for (const key of targetKeys) {
          if (typeof form.enc !== "undefined" && typeof form.enc[key] !== "undefined") {
            body[key] = form.enc[key];
          }
        }
      } else if (this.boardId === 126) {
        let i = 0;
        if (body.group1 && body.group1.length > 0) {
          for (i = 0; i < body.group1.length; i++) {
            const data = body.group1[i];
            data.name = form.enc.group1[i].name;
            data.phone = form.enc.group1[i].phone;
          }
        }

        i = 0;
        if (body.group2 && body.group2.length > 0) {
          for (i = 0; i < body.group2.length; i++) {
            const data = body.group2[i];
            data.name = form.enc.group2[i].name;
            data.phone = form.enc.group2[i].phone;
          }
        }
      } else if (this.boardId === 136) {
        let i = 0;
        if (body.group1 && body.group1.length > 0) {
          for (i = 0; i < body.group1.length; i++) {
            const data = body.group1[i];
            data.name = form.enc.group1[i].name;
            data.phone = form.enc.group1[i].phone;
          }
        }

        i = 0;
        if (body.group2 && body.group2.length > 0) {
          for (i = 0; i < body.group2.length; i++) {
            const data = body.group2[i];
            data.name = form.enc.group2[i].name;
            data.phone = form.enc.group2[i].phone;
          }
        }
      } else if (this.boardId === 138) {
        let i = 0;
        if (body.group1 && body.group1.length > 0) {
          for (i = 0; i < body.group1.length; i++) {
            const data = body.group1[i];
            data.name = form.enc.group1[i].name;
            data.phone = form.enc.group1[i].phone;
          }
        }

        i = 0;
        if (body.group2 && body.group2.length > 0) {
          for (i = 0; i < body.group2.length; i++) {
            const data = body.group2[i];
            data.name = form.enc.group2[i].name;
            data.phone = form.enc.group2[i].phone;
          }
        }
      } else if (this.boardId === 141) {
        let i = 0;
        if (body.group1 && body.group1.length > 0) {
          for (i = 0; i < body.group1.length; i++) {
            const data = body.group1[i];
            data.name = form.enc.group1[i].name;
            data.phone = form.enc.group1[i].phone;
          }
        }
      }
      return form;
    },
    __writeSaveApprovalPostContent(form) {
      const body = form.body;

      // 86
      if (this.boardId === 86) {
        let i = 0;
        if (body.inputB) {
          for (i = 0; i < body.inputB.length; i++) {
            const data = body.inputB[i];
            data.value1 = this.__removeComma(data.value1);
            data.value2 = this.__removeComma(data.value2);
            data.value3 = this.__removeComma(data.value3);
          }
        }
        if (body.inputC) {
          for (i = 0; i < body.inputC.length; i++) {
            const data = body.inputC[i];
            data.value1 = this.__removeComma(data.value1);
            data.value2 = this.__removeComma(data.value2);
            data.value3 = this.__removeComma(data.value3);
          }
        }
      }

      // 106
      else if (this.boardId === 106) {
        let i = 0;
        if (body.inputB) {
          for (i = 0; i < body.inputB.length; i++) {
            const data = body.inputB[i];
            data.value1 = this.__removeComma(data.value1);
            data.value2 = this.__removeComma(data.value2);
            data.value3 = this.__removeComma(data.value3);
          }
        }
      } else if (this.boardId === 117) {
        form = this.__writeSaveApprovalPostContent117(form);
      }

      // 126
      else if (this.boardId === 126) {
        form = this.__writeSaveApprovalPostContent126(form);
      }

      // 136
      else if (this.boardId === 136) {
        form = this.__writeSaveApprovalPostContent136(form);
      }

      // 138
      else if (this.boardId === 138) {
        form = this.__writeSaveApprovalPostContent138(form);
      }

      // 141
      else if (this.boardId === 141) {
        form = this.__writeSaveApprovalPostContent141(form);
      }

      // 154
      else if (this.boardId === 154) {
        let i = 0;
        if (body.inputB) {
          for (i = 0; i < body.inputB.length; i++) {
            const data = body.inputB[i];
            data.value1 = this.__removeComma(data.value1);
            data.value2 = this.__removeComma(data.value2);
            data.value3 = this.__removeComma(data.value3);
          }
        }
        if (body.inputC) {
          for (i = 0; i < body.inputC.length; i++) {
            const data = body.inputC[i];
            data.value1 = this.__removeComma(data.value1);
            data.value2 = this.__removeComma(data.value2);
            data.value3 = this.__removeComma(data.value3);
          }
        }
      }

      // 155
      else if (this.boardId === 155) {
        let i = 0;
        if (body.inputB) {
          for (i = 0; i < body.inputB.length; i++) {
            const data = body.inputB[i];
            data.value1 = this.__removeComma(data.value1);
            data.value2 = this.__removeComma(data.value2);
            data.value3 = this.__removeComma(data.value3);
          }
        }
      }

      // 250
      else if (this.boardId === 250) {
        let i = 0;
        if (body.inputB) {
          for (i = 0; i < body.inputB.length; i++) {
            const data = body.inputB[i];
            data.value1 = this.__removeComma(data.value1);
            data.value2 = this.__removeComma(data.value2);
            data.value3 = this.__removeComma(data.value3);
          }
        }
      }

      return form;
    },
    __writeSaveApprovalPostContent117(form) {
      const body = form.body;
      const targetKeys = [
        "inputC_1",
        "inputC_2",
        "inputC_4",
        "inputC_5",
        "inputC_7",
        "inputC_8",
        "inputC_9",
        "inputC_10",
        "inputC_11",
        "inputC_12",
        "inputC_13",
        "inputC_14",
        "inputC_15",
        "inputC_16",
        "inputC_17",
        "inputC_18",
        "inputC_19",
        "inputC_20",
        "inputD_1",
        "inputD_2",
        "inputD_3",
        "inputD_4",
        "inputD_5",
        "inputD_6",
        "inputD_7",
        "inputE_1",
        "inputE_2",
        "inputE_3",
        "inputE_4",
      ];

      const maskedName = this.__maskName(body.inputC_1);

      // 암호화
      form.enc = {};
      for (const key of targetKeys) {
        form.enc[key] = body[key];
        body[key] = "";
      }
      body.inputC_1 = maskedName;

      form.body = body;
      return form;
    },
    __writeSaveApprovalPostContent126(form) {
      const body = form.body;
      // 암호화
      form.enc = {
        group1: [],
        group2: [],
      };
      if (body.group1) {
        for (const data of body.group1) {
          form.enc.group1.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }
      if (body.group2) {
        for (const data of body.group2) {
          form.enc.group2.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }

      // enc 에 사용하는 내용을 본문에서 제거
      let i = 0;
      if (body.group1 && body.group1.length > 0) {
        for (i = 0; i < body.group1.length; i++) {
          const data = body.group1[i];
          data.name = "";
          data.phone = "";
        }
      }

      i = 0;
      if (body.group2 && body.group2.length > 0) {
        for (i = 0; i < body.group2.length; i++) {
          const data = body.group2[i];
          data.name = "";
          data.phone = "";
        }
      }
      form.body = body;
      return form;
    },
    __writeSaveApprovalPostContent136(form) {
      const body = form.body;
      // 암호화
      form.enc = {
        group1: [],
        group2: [],
      };
      if (body.group1) {
        for (const data of body.group1) {
          form.enc.group1.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }
      if (body.group2) {
        for (const data of body.group2) {
          form.enc.group2.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }

      // enc 에 사용하는 내용을 본문에서 제거
      let i = 0;
      if (body.group1 && body.group1.length > 0) {
        for (i = 0; i < body.group1.length; i++) {
          const data = body.group1[i];
          data.name = "";
          data.phone = "";
        }
      }

      i = 0;
      if (body.group2 && body.group2.length > 0) {
        for (i = 0; i < body.group2.length; i++) {
          const data = body.group2[i];
          data.name = "";
          data.phone = "";
        }
      }
      form.body = body;
      return form;
    },
    __writeSaveApprovalPostContent138(form) {
      const body = form.body;
      // 암호화
      form.enc = {
        group1: [],
        group2: [],
      };
      if (body.group1) {
        for (const data of body.group1) {
          form.enc.group1.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }
      if (body.group2) {
        for (const data of body.group2) {
          form.enc.group2.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }

      // enc 에 사용하는 내용을 본문에서 제거
      let i = 0;
      if (body.group1 && body.group1.length > 0) {
        for (i = 0; i < body.group1.length; i++) {
          const data = body.group1[i];
          data.name = "";
          data.phone = "";
        }
      }

      i = 0;
      if (body.group2 && body.group2.length > 0) {
        for (i = 0; i < body.group2.length; i++) {
          const data = body.group2[i];
          data.name = "";
          data.phone = "";
        }
      }
      form.body = body;
      return form;
    },
    __writeSaveApprovalPostContent141(form) {
      const body = form.body;
      // 암호화
      form.enc = {
        group1: [],
      };
      if (body.group1) {
        for (const data of body.group1) {
          form.enc.group1.push({
            name: data.name,
            phone: data.phone,
          });
        }
      }

      // enc 에 사용하는 내용을 본문에서 제거
      let i = 0;
      if (body.group1 && body.group1.length > 0) {
        for (i = 0; i < body.group1.length; i++) {
          const data = body.group1[i];
          data.name = "";
          data.phone = "";
        }
      }
      form.body = body;
      return form;
    },
    async writeLoadApprovalPost() {
      const boardSlug = this.boardSlug;
      const postId = this.$route.params.postId;
      let post = {};
      await this.$store.dispatch("approval/LOAD_POST", {boardSlug, postId}).then((value) => {
        post = value.post;
        this.writeDocProjectId = post.id;
        return value;
      });

      if (!this.$store.state.approval.postInfo) {
        alert("열람 권한이 없습니다.");
        this.writeOldForm = JSON.parse(JSON.stringify(this.form));
        this.moveTabPage("list");
        return;
      }
      // 내용
      if (post.post_content) {
        let form = JSON.parse(post.post_content);

        if (!form.body["fileList"]) {
          form.body.fileList = [];
        }
        if (!form.body["formList"]) {
          form.body.formList = [];
        }

        // enc 내용을 본문에 추가하기
        form = this.__writeLoadApprovalPostContent(form);
        this.form = form;
      }

      // 결재프로세스
      this.writeDocInfo = this.$store.state.approval.document;
      this.writeDocInfo.slug = this.boardSlug;
    },
    async writeSaveApprovalPost(type, approvalLine) {
      const approvalDocument = this.$refs["approvalDocument"];
      if (approvalDocument.validate) {
        if (!approvalDocument.validate()) {
          return;
        }
      }

      let form = this.form;
      form.header.full = `${form.header.year}-${form.header.month > 9 ? form.header.month : `0${form.header.month}`}-01`;
      form.summary = this.form.body.summary;
      form = this.__writeSaveApprovalPostContent(form);

      const projectId = this.projectId;
      const boardSlug = this.boardSlug;
      const title = this.form.body.title;
      const content = JSON.stringify(form);

      if (type === "create") {
        await this.$store.dispatch("approval/CREATE_POST", {
          isTemp: 1,
          boardSlug,
          projectId,
          title,
          content,
          approvalLine,
          security: "normal",
          priority: "medium",
        });
        alert("임시저장 되었습니다");
      } else if (type === "update") {
        const postId = this.postId;
        await this.$store.dispatch("approval/UPDATE_POST", {
          postId,
          unTemp: "n",
          boardSlug,
          projectId,
          title,
          content,
          approvalLine,
          security: "normal",
          priority: "medium",
        });
        alert("임시저장 되었습니다");
      } else if (type === "create_upload") {
        await this.$store.dispatch("approval/CREATE_POST", {
          boardSlug,
          projectId,
          title,
          content,
          approvalLine,
          security: "normal",
          priority: "medium",
        });
        alert("상신 되었습니다");
      } else if (type === "upload") {
        const postId = this.postId;
        await this.$store.dispatch("approval/UPDATE_POST", {
          postId,
          unTemp: "y",
          boardSlug,
          projectId,
          title,
          content,
          approvalLine,
          security: "normal",
          priority: "medium",
        });
        alert("상신 되었습니다");
      }
      this.writeOldForm = JSON.parse(JSON.stringify(this.form));
      this.moveTabPage("list");
    },
    async writeLoadBoardPost() {
      const boardId = this.boardId;
      const postId = this.$route.params.postId;
      await this.$store.dispatch("board/LOAD_POST", {
        boardId,
        postId,
      });

      // 내용
      const post = this.$store.state.board.postInfo;
      this.writeDocProjectId = post.project_id;
      if (post.post_content) {
        this.form = JSON.parse(post.post_content);
        if (!this.form.body["fileList"]) {
          this.form.body.fileList = [];
        }
        if (!this.form.body["formList"]) {
          this.form.body.formList = [];
        }
      }
    },
    async writeSaveBoardPost(type) {
      let normalDocument = this.$refs["normalDocumentComponent"];
      // 만약 normalDocument 값이 배열일 경우, 배열의 첫번째 값을 가져온다
      if (Array.isArray(normalDocument)) {
        normalDocument = normalDocument[0];
      }

      // 만약 normalDocument.validate 메서드가 존재하면 호출한다
      if (normalDocument.validate) {
        const validated = normalDocument.validate();
        // 검증 실패했으면 빠져나간다
        if (validated) {
          alert(validated);
          return;
        }
      }

      const form = this.form;
      form.header.full = `${form.header.year}-${form.header.month > 9 ? form.header.month : `0${form.header.month}`}-01`;
      form.summary = this.form.body.summary;
      form.enc = this.form.body.enc;

      // 카카오톡 발송 번호 추출
      const kakaoPhoneNumber = form.body.kakaoPhoneNumber;
      // 카카오톡 발송 번호 제거
      delete form.body.kakaoPhoneNumber;

      const projectId = this.projectId;
      const boardId = this.boardId;
      const title = this.form.body.title;
      const content = JSON.stringify(form);

      if (type === "create") {
        // 카카오톡 알림 설정 ---------------------
        if (kakaoPhoneNumber) {
          const authorName = this.$store.state.auth.userInfo.name;
          const wroteAt = new Date().toISOString().split("T")[0];
          const host = window.location.host;
          const link = `${host}/project/${this.projectId}/tab/${this.boardId}`;
          const docName = this.tabItems[boardId].label;

          this.$store.dispatch("kakao/SEND_KAKAO", {
            phone: kakaoPhoneNumber,
            author: authorName,
            wrote_at: wroteAt,
            doc_name: docName,
            link,
          }).then();
        }
        // END 카카오톡 알림 설정 -----------------

        await this.$store.dispatch("board/CREATE_POST", {
          projectId,
          boardId,
          title,
          content,
        });
      } else if (type === "update") {
        const postId = this.postId;
        await this.$store.dispatch("board/UPDATE_POST", {
          projectId,
          boardId,
          postId,
          title,
          content,
        });
      }
      this.writeOldForm = JSON.parse(JSON.stringify(this.form));
      this.moveTabPage("list");
    },

    async writeOnClickApprovalDelete() {
      // 삭제
      if (confirm("삭제하시겠습니까?")) {
        const boardSlug = this.boardSlug;
        const postId = this.$route.params.postId;
        await this.$store.dispatch("approval/DELETE_POST", {
          boardSlug,
          postId,
        });
        this.writeOldForm = JSON.parse(JSON.stringify(this.form));
        this.writeOnClickApprovalClose();
      }
    },
    async writeOnClickApprovalOk() {
      // 승인
      const postId = this.$route.params.postId;
      await this.$store.dispatch("approval/APPROVE_OK", {postId});
      this.writeOldForm = JSON.parse(JSON.stringify(this.form));
      this.writeOnClickApprovalClose();
    },
    async writeOnClickApprovalNo(text) {
      // 반려
      const postId = parseInt(this.$route.params.postId);
      const comment = text;
      await this.$store.dispatch("approval/APPROVE_NO", {postId, comment});
      this.writeOldForm = JSON.parse(JSON.stringify(this.form));
      this.writeOnClickApprovalClose();
    },
    writeOnClickApprovalSave(approvalLine) {
      this.writeSaveApprovalPost(this.postId ? "update" : "create", approvalLine);
    },
    writeOnClickApprovalUpload(approvalLine) {
      // 상신
      if (this.postId) {
        this.writeSaveApprovalPost("upload", approvalLine);
      } else {
        this.writeSaveApprovalPost("create_upload", approvalLine);
      }
    },
    writeOnClickApprovalRecall(approvalLine) {
      // 결재문서 회수
      if (confirm("회수 후 임시저장 상태로 변경하시겠습니까?")) {
        this.writeSaveApprovalPost("update", approvalLine);
      }
    },
    writeOnClickApprovalClose() {
      // 닫기
      this.moveTabPage("list");
    },
    async writeOnClickNormalRemove() {
      this.writeOldForm = JSON.parse(JSON.stringify(this.form));
      const boardId = this.boardId;
      const postId = this.postId;
      await this.$store.dispatch("board/DELETE_POST", {boardId, postId});
      this.writeOldForm = JSON.parse(JSON.stringify(this.form));
      this.moveTabPage("list");
    },
    writeOnClickNormalSave() {
      if (this.postId) {
        this.writeSaveBoardPost("update");
      } else {
        this.writeSaveBoardPost("create");
      }
    },
    writeOnClickPrevPost() {
      this.popup.loadPrevBoard = true;
    },
    writeSaveButtonControl(value) {
      if (this.$refs["refNormalDocument"] && this.$refs["refNormalDocument"].saveButtonControl) {
        this.$refs["refNormalDocument"].saveButtonControl(value);
      }
    },
    writeRemoveButtonControl(value) {
      if (this.$refs["refNormalDocument"] && this.$refs["refNormalDocument"].removeButtonControl) {
        this.$refs["refNormalDocument"].removeButtonControl(value);
      }
    },
    writeSetPrevBoardOptions (value) {
      const boardId = value.boardId;
      const btnLabel = value.btnLabel;
      const prevBoardSelectRow = value.prevBoardSelectRow;
      this.writePrevBoardOptions.boardId = boardId;
      this.writePrevBoardOptions.title = btnLabel;
      this.writePrevBoardOptions.prevBoardSelectRow = prevBoardSelectRow;

      this.$nextTick(() => {
        this.$refs.refNormalDocument.setPrevBoardOptions({
          btnLabel,
        });
      });
    },
    writeOnClickReTempsave(approvalLine) {
      if (confirm("재상신을 할 경우,\n기존 문서는 유지 되고, 내용이 복사되어 임시저장됩니다.\n재상신 하시겠습니까?")) {
        this.saveApprovalPost("create", approvalLine);
      }
    },
    writeOnClickSaveMultiple(forms) {
      this.loading(true);
      const date = new Date();
      const header = {...this.header, full: date.format("yyyy-MM-dd")};
      const posts = forms.posts.map((form) => {
        const content = {
          header,
          body: {
            ...form
          },
        };
        return {
          title: this.pageTitle,
          content: JSON.stringify(content),
          projectId: this.projectId,
          company_member_join: true,
        }
      });
      HttpRequest.put(`/api/v1/board/post/${this.boardId}/multiple`, { posts })
        .then((response) => {
          if (forms.callback) {
            forms.callback(true, response);
          }
          this.loading(false);
          this.customAlert(`${this.pageTitle} 엑셀 업로드가 완료되었습니다`, this.pageTitle);
        })
        .catch(({ response }) => {
          if (forms.callback) {
            forms.callback(false, response);
          }
          this.loading(false);
          this.customAlert("서버에서 오류가 발생했습니다. 관리자에게 문의해주세요");
        });
    },

    // TODO : ======================== popup ======================== //
    prevBoardSelectRow (value) {
      const func = this.writePrevBoardOptions.prevBoardSelectRow;
      if (func) {
        func(value)
      } else {
        this.popupUpdatePrevForm(value);
      }
    },
    popupUpdatePrevForm(data) {
      // 가능하면 이런건 없애야지...
      if (this.boardId === 261) {
        delete data.headerDate;
        delete data.stdInfo;
        delete data.fieldInfo;

        delete data.hideBudgetDay1;
        delete data.hideBudgetDay2;
        delete data.budgetDay1Total;
        delete data.budgetDay2Total;

        const budgetDay1 = data.budgetDay1.map((_day) => {
          return {..._day, readonly: false, yesterday: 0, total: 0};
        });
        const budgetDay2 = data.budgetDay2.map((_day) => {
          return {..._day, readonly: false, yesterday: 0, total: 0};
        });

        this.form.body = {...this.form.body, ...data, budgetDay1, budgetDay2};

        const setBudgetDayOldData = new CustomEvent("setBudgetDayOldData");
        window.dispatchEvent(setBudgetDayOldData);
      } else {
        this.form.body = data;
      }
    },

  },
};
</script>

<style scoped></style>
